module.exports = __webpack_public_path__ + "static/media/SingleCoupon_instructionContent.ece1e3a3.png";